<script>
import { onMount } from 'svelte';
import { createEventDispatcher } from 'svelte';
import 'codemirror/lib/codemirror.css';
import CodeMirror from 'codemirror/src/codemirror.js';
import './python-mode.mjs';

export let value;
export function undo() { editor.undo(); }

const dispatch = createEventDispatcher();
function evaluate() { dispatch('execute', {value}); }
function changed() { dispatch('change', {}); }


let editor;
let element;

const options = {
	mode: 'python',
	lineNumbers: true,
	indentWithTabs: false,
	indentUnit: 4,
	extraKeys: {
		'Enter': 'newlineAndIndent',
        'Shift-Enter': evaluate,
        'Ctrl-Enter': evaluate,
        'Tab': function(cm) {
            var spaces = Array(cm.getOption("indentUnit") + 1).join(" ");
            cm.replaceSelection(spaces);
        }
	},
	smartIndent: true,
};


onMount(() => {
      if (editor != null) element.innerHTML = ''
  
      editor = CodeMirror(element, {...options, value})
      editor.on('change', () => {
        value = editor.getValue();
        changed();
      })
    })

export function update(txt) {
    if (editor == null) return;
    editor.setValue(txt);
}
</script>
  
<div class="codemirror-container" bind:this={element}/>

<style>
.codemirror-container {
    height: 100%;
    background-color: var(--back-light);
}
.codemirror-container :global(.CodeMirror) {
    font-family: var(--font-mono);
    font-size: .9rem;
    background: transparent;
    height: 100%;
}
.codemirror-container :global(.CodeMirror pre) {
    line-height: 1.5;
}
.codemirror-container :global(.CodeMirror-gutter) {
    background-color: var(--back-light);
}
.codemirror-container :global(.CodeMirror-linenumber) {
    padding-right: 1em;
    font-size: .8rem;
}
.codemirror-container :global(.CodeMirror-gutters) {
border-right: none;
}
</style>
